import React, { Component } from 'react';


class ManualProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }

    render() {
        const percentage = {
            width: `${this.props.value}%`,
            backgroundColor: `${this.props.color}`
        }
        return (
            <div className="ma-progress-container">
                <div className="ma-main">
                    <div className="ma-content" style={percentage}> </div>
                    <label className="ma-label">{this.props.valueString}</label>
                </div>
            </div>
        );
    }

}

export default ManualProgress;
